import React from "react";
import ContentCard, { ContentCardProps } from "../../shared/ContentCard";

interface DownloadTabProps {}

const DownloadTab: React.FC<DownloadTabProps> = (props) => {
  const downloadIcon = "/images/downlaod.svg";
  const downlodables: Array<ContentCardProps> = [
    {
      text: "Document name",
      actionElement: (
        <div className="download-icon">
          <img
            src={downloadIcon}
            alt="download icon"
            className="simple-icon"
            width={20}
            height={30}
          />
        </div>
      ),
    },
    {
      text: "Document name",
      actionElement: (
        <div className="download-icon">
          <img
            src={downloadIcon}
            alt="download icon"
            className="simple-icon"
            width={20}
            height={30}
          />
        </div>
      ),
    },
    {
      text: "Document name",
      actionElement: (
        <div className="download-icon">
          <img
            src={downloadIcon}
            alt="download icon"
            className="simple-icon"
            width={20}
            height={30}
          />
        </div>
      ),
    },
  ];
  return (
    <div className="content-card-wrap">
      {downlodables.map((data, index) => (
        <ContentCard
          key={index}
          text={data.text}
          actionElement={data.actionElement}
        />
      ))}
    </div>
  );
};

export default DownloadTab;
